//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import ClientId from '@models/ClientId';

export const getClientId = createSelector(
  (state: ICuralateStore) => state.session.client,
  (client) => ClientId.fromString(client.id),
);
